import { render, staticRenderFns } from "./dropdown_container.vue?vue&type=template&id=9af29b72&scoped=true&"
import script from "./dropdown_container.vue?vue&type=script&lang=js&"
export * from "./dropdown_container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af29b72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9af29b72')) {
      api.createRecord('9af29b72', component.options)
    } else {
      api.reload('9af29b72', component.options)
    }
    module.hot.accept("./dropdown_container.vue?vue&type=template&id=9af29b72&scoped=true&", function () {
      api.rerender('9af29b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/abstracts/dropdown_container.vue"
export default component.exports